import React, {
  FC
} from 'react';
import {
  useTranslation
} from 'react-i18next';

import {
  NotificationContainer,
  NotificationGroupContainer,
} from 'src/entities/NotificationsRoute';
import {
  getTimeAgo, ROUTE, organisationTab
} from 'src/shared/utils';
import {
  Button
} from 'src/shared/components';

import * as Style from './Notifications.styles';

interface OrgAdminMsgNotificationsProps {
  isNew: boolean;
  message: string;
  createdAt: string;
  organizationName: string;
  getHighlightedText: (text: string) => (string | JSX.Element)[];
  isSuggestion?: boolean;
  fromUserName?: string;
  organizationId?: string;
}

export const OrgAdminMsgNotifications: FC<OrgAdminMsgNotificationsProps> = ({
  isNew,
  message,
  createdAt,
  organizationName,
  getHighlightedText,
  isSuggestion,
  fromUserName,
  organizationId,
}) => {
  const {
    t
  } = useTranslation();

  if (isSuggestion && fromUserName && organizationId) {
    const suggestionsLink = `/${ROUTE.ORGANISATION}/${organizationId}?${organisationTab}=suggestions`;

    return (
      <NotificationContainer $isNew={isNew}>
        <Style.Description>
          <Style.NotificationHeader>
            <Style.NotificationDate>
              {`${getTimeAgo(createdAt)} ${t('date.ago')}`}
            </Style.NotificationDate>
          </Style.NotificationHeader>

          <Style.NotificationText>
            <Style.NotificationBoldText>
              {getHighlightedText(fromUserName)}
            </Style.NotificationBoldText>

            {` ${t('suggestions.sentSuggestion')}`}
          </Style.NotificationText>

          <Button
            variant="big-grey-bordered"
            className="w-max text-15-20 font-bold !px-3 !py-2 !h-9"
            to={suggestionsLink}
            component="link"
          >
            <p className="shrink-0">{t('suggestions.goToSuggestions')}</p>
          </Button>
        </Style.Description>
      </NotificationContainer>
    );
  }

  return (
    <NotificationContainer $isNew={isNew}>
      <Style.HeaderWithAvatarWrapper>
        <Style.Description>
          <Style.NotificationHeader>
            <Style.NotificationDate>
              {`${getTimeAgo(createdAt)} ${t('date.ago')}`}
            </Style.NotificationDate>
          </Style.NotificationHeader>

          <Style.NotificationText>
            <Style.NotificationBoldText>
              {getHighlightedText(organizationName)}
            </Style.NotificationBoldText>

            {` ${t('organisation.adminSendMessage')}`}
          </Style.NotificationText>
        </Style.Description>
      </Style.HeaderWithAvatarWrapper>

      <NotificationGroupContainer
        $wasRead={!isNew}
        $width={468}
        $mediumFont
      >
        {message}
      </NotificationGroupContainer>
    </NotificationContainer>
  );
};
